import React from 'react';

export default function Intro(){
    return(
        <div className='intro'>
            <div className='onetitle'>
                <h1 className='introtext' id = "half">Half Developer <br></br> Half Designer</h1>
            </div>
            <div className='twotitle'>
                <h1 className='introtext' id = "human">All Human</h1>
            </div>
        </div>
    );
}